<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранный аккаунт {{currentVkToken.name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteVkToken()">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'confirmDeletionVkModal',
  data() {
    return {
    };
  },
  computed: {
    isOpen: {
      get(){
        return this.$store.getters.IS_CONFIRM_DELETION_VK_MODAL_OPENED;
      },
      set(){
        this.$store.dispatch('CONFIRM_DELETION_TEMPLATE_MODAL', false);
      }
    },
    currentVkToken: {
      get(){
        return this.$store.getters.GET_CURRENT_VK_TOKEN;
      },
      set(value){
        this.$store.commit("SET_CURRENT_VK_TOKEN", value);
      }
    },
  },
  methods: {
    close() {
      this.$store.dispatch('CONFIRM_DELETION_VK_MODAL', false);
    },
    deleteVkToken(){
      this.$store.dispatch('DELETE_VK_TOKEN', this.currentVkToken.id)
        .then(() => {
          this.$toast.success('Аккаунт был удален');
          this.$store.dispatch("GET_VK_TOKENS");
          this.$store.dispatch('CONFIRM_DELETION_VK_MODAL', false);
        })
        .catch(() => {
          this.$toast.error('Неизвестная ошибка');
        });

        this.$store.dispatch("CURRENT_VK_TOKEN", { });
    },
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    }
  },
};
</script>
